export const MAPS_CONSENT_KEY = 'mtb_ridewithgps_consent';
const eventName = 'mtb:maps-consent-changed';
let current;
let initialized = false;

function read(key) {
    try { return JSON.parse(window.localStorage.getItem(key)); } catch { return null; }
}

function valid(record) {
    return record?.hasConsented === true
        && Number.isFinite(Date.parse(record.timestamp))
        && Date.parse(record.expiresAt) > Date.now();
}

function save(record) {
    current = record;
    try { window.localStorage.setItem(MAPS_CONSENT_KEY, JSON.stringify(record)); } catch { /* Current visit only. */ }
    window.dispatchEvent(new CustomEvent(eventName, { detail: { allowed: hasMapConsent() } }));
}

export function setMapConsent(allowed, source = 'map', timing = {}) {
    const now = new Date();
    save({
        engine: 'mtb-ridewithgps',
        version: '1.0.0',
        timestamp: timing.timestamp || now.toISOString(),
        expiresAt: timing.expiresAt || new Date(now.getTime() + 180 * 86400000).toISOString(),
        status: allowed ? 'accepted' : 'rejected',
        source,
        hasConsented: true,
        categories: { ridewithgps: allowed },
    });
}

export function hasMapConsent() {
    return valid(current) && current.status === 'accepted' && current.categories?.ridewithgps === true;
}

function syncGeneral(consent, live = false) {
    if (!valid(consent)) return;
    const accepted = consent.categories?.preferences;
    if (typeof accepted !== 'boolean') return;
    if (!live && valid(current) && Date.parse(current.timestamp) >= Date.parse(consent.timestamp)) return;
    setMapConsent(accepted, 'cookie-consent', consent);
}

export function initializeMapConsent() {
    if (initialized) return;
    initialized = true;
    const stored = read(MAPS_CONSENT_KEY);
    current = stored?.engine === 'mtb-ridewithgps' && stored.version === '1.0.0' && valid(stored) ? stored : null;
    const general = window.CookieConsent?.getConsent() || read('cookie_consent');
    if (general?.engine === 'cookie-kit-core') syncGeneral(general);
    window.addEventListener('cookie-consent:consentChanged', event => syncGeneral(event.detail?.consent, true));
    window.addEventListener('cookie-consent:ready', event => syncGeneral(event.detail?.consent));
    window.addEventListener('cookie-consent:consentCleared', () => setMapConsent(false, 'cookie-consent'));
    window.addEventListener('focus', () => window.dispatchEvent(new CustomEvent(eventName, { detail: { allowed: hasMapConsent() } })));
    window.addEventListener('storage', event => {
        if (event.key !== MAPS_CONSENT_KEY && event.key !== 'cookie_consent' && event.key !== null) return;
        const record = read(MAPS_CONSENT_KEY);
        current = record?.engine === 'mtb-ridewithgps' && record.version === '1.0.0' && valid(record) ? record : null;
        const consent = read('cookie_consent');
        if (consent?.engine === 'cookie-kit-core') syncGeneral(consent);
        window.dispatchEvent(new CustomEvent(eventName, { detail: { allowed: hasMapConsent() } }));
    });
}
